import { AnyUser } from "@megaron/access-control";
import { HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";

import { accountActions } from "./account";
import { blikCheckActions } from "./blikCheck";
import { pitActions } from "./pit";
import { rewardActions } from "./reward";

export const cashRewardsHttpService = HttpService({
  ...blikCheckActions,
  ...pitActions,
  ...accountActions,
  ...rewardActions,
});
export type CashRewardsHandlers = HandlerMap<typeof cashRewardsHttpService, AnyUser>;
